var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.353 9.122L9.5 13.285V2.502a.5.5 0 0 1 1 0v10.783l4.147-4.163a.496.496 0 0 1 .707 0 .504.504 0 0 1 0 .71l-4.999 5.02a.492.492 0 0 1-.709 0l-4.999-5.02a.504.504 0 0 1 0-.71.499.499 0 0 1 .707 0zM17.467 17c.294 0 .533.224.533.5s-.239.5-.533.5H2.533C2.24 18 2 17.776 2 17.5s.239-.5.533-.5h14.934z","fillRule":"evenodd"}));
}

Download.defaultProps = {"width":"20","height":"20"};

module.exports = Download;

Download.default = Download;
